import i18next, { changeLanguage } from 'i18next'

export const updateLanguage = (language: string) => {
  changeLanguage(language)
  document.documentElement.setAttribute('lang', language)
  document.documentElement.setAttribute('dir', i18next.dir(language))
}
